<template>
  <div class="app-container">
    <div class="tb" style="height: 100%">
      <div class="main tb">
        <div class="lr between">
          <div class="add-input">
            <el-input v-model="table.query.keyWord" placeholder="请输入关键字查询" clearable
                      suffix-icon="el-icon-search" @change="search(true)"/>
          </div>
          <div style="display: flex;justify-content: flex-end;">
            <el-button type="primary" size="small" @click="openDialog(null, false)"
                       icon="el-icon-plus">新增角色
            </el-button>
          </div>
        </div>
        <div class="main" style="margin-top: 20px;">
          <el-table :data="table.data" height="600px" border
                    :header-cell-style="{background:'#fafafa',color:'#000000'}" v-loading="tableLoading">
            <el-table-column show-overflow-tooltip fixed="left" label="序号" type="index" width="55"
                             align="center"/>
            <el-table-column show-overflow-tooltip label="角色名" width="260" align="center"
                             prop="name"></el-table-column>
            <el-table-column show-overflow-tooltip label="菜单" width="400" align="center" prop="menuNames"
                             :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column show-overflow-tooltip label="类型" width="400" align="center" prop="menuNames"
                             :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <span v-if="scope.row.id == 1 || scope.row.id == 2 || scope.row.id == 3 || scope.row.id == 4 || scope.row.id == 5 || scope.row.id == 6 || scope.row.id == 7">系统预置</span>
                <span v-else>用户自定义</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip label="备注" align="center"
                             prop="remark"></el-table-column>
            <el-table-column show-overflow-tooltip label="操作" width="300" align="center">
              <template slot-scope="scope">
                <!-- 超级管理员及管理员角色不可操作 -->
                <el-button type="text" @click="openDialog(scope.row, true)" :disabled="scope.row.id == 1 || scope.row.id == 2 || scope.row.id == 3 || scope.row.id == 4 || scope.row.id == 5 || scope.row.id == 6 || scope.row.id == 7">编辑</el-button>
                <el-button type="text" @click="distributeMenu(scope.row, true)" :disabled="scope.row.id == 1 || scope.row.id == 4">分配菜单</el-button>
                <el-button type="text" style="color: #ff4949;" @click="deleteRole(scope.row.id)" v-if="scope.row.id != 1 && scope.row.id != 2 && scope.row.id != 3 && scope.row.id != 4 && scope.row.id != 5 && scope.row.id != 6 && scope.row.id != 7">删除</el-button>
                <el-button type="text" disabled v-else>删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="lr end" style="margin-top: 20px;">
          <el-pagination :total="table.total" :page-size="table.query.size" :current-page="table.query.page"
                         layout="total, prev, pager, next" @current-change="currentPageChange"/>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="roleDialog.visible" :close-on-click-modal="false" width="40%"
               :title="!isEdit ? '新增角色' : '编辑角色'">
      <el-form ref="roleForm" label-position="right" label-width="100px" :model="roleDialog.formData"
               :rules="rules">
        <el-form-item label="角色名：" prop="name">
          <el-input placeholder="请输入角色名" v-model="roleDialog.formData.name"
                    clearable/>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input type="textarea" :rows="3" placeholder="请输入备注" v-model="roleDialog.formData.remark" clearable/>
        </el-form-item>
      </el-form>
      <div class="dialog-btn">
        <el-button @click="roleDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="saveOrUpdateRole" :loading="loading">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="menuDialog.visible" :close-on-click-modal="false" width="15%" title="分配菜单">
      <div style="display: flex;justify-content: flex-start">
        <el-tree
          ref="menuTree"
          :data="menuDialog.data"
          show-checkbox
          node-key="id"
          default-expand-all
          :props="menuDialog.defaultProps">
        </el-tree>
      </div>
      <div class="dialog-btn">
        <el-button @click="menuDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="updateRoleMenu" :loading="menuDialog.loading">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>


import {getPageList, saveOrUpdateData, deleteData} from "@/api/role";
import {getAllMenus, getMenus} from "@/api/menu";

export default {
  data() {
    return {
      table: {
        query: {
          page: 1,
          size: 10,
          keyWord: ''
        },
        total: 0,
        data: []
      },
      roleDialog: {
        formData: {
          name: '',
          menuIds: '',
          remark: ''
        },
        visible: false
      },
      rules: {
        name: [
          {trigger: 'blur', required: true, message: '请输入角色名'}
        ]
      },
      loading: false,
      tableLoading: false,
      isEdit: false,
      roles: [],
      menuDialog: {
        data: [],
        visible: false,
        loading: false,
        defaultProps: {
          children: 'children',
          label: 'name'
        }
      },
      menus: []
    }
  },
  mounted() {
    this.getMenus()
    this.getMenuTree()
  },
  methods: {
    // 搜索框查询
    search(flag) {
      this.tableLoading = true
      if (flag) {
        this.table.query.page = 1
      }
      const params = {
        current: this.table.query.page,
        size: this.table.query.size,
        keyWord: this.table.query.keyWord
      }
      getPageList(params).then(response => {
        if (response.code == 200) {
          // 查询成功
          this.table.data = response.data
          this.table.total = response.count
          // 格式化菜单显示
          if (this.table.data && this.table.data.length > 0) {
            for (let item of this.table.data) {
              item.menuNames = this.formatMenu(item.menuIds)
            }
          }
        } else {
          // 查询失败
          this.$message.error('查询失败!')
        }
        this.tableLoading = false
      })
    },
    // 新增修改角色
    saveOrUpdateRole() {
      this.loading = true
      this.$refs['roleForm'].validate(async (valid) => {
        if (valid) {
          saveOrUpdateData(this.roleDialog.formData).then(response => {
            if (response.code == 200) {
              // 操作成功
              this.$message.success('操作成功!')
              this.roleDialog.visible = false
              this.search(false)
            } else {
              // 操作失败
              this.$message.error('操作失败!')
            }
            this.loading = false
          })
        } else {
          this.loading = false
        }
      })
    },
    // 打开弹窗
    openDialog(data, isEdit) {
      this.isEdit = isEdit
      if (isEdit) {
        this.roleDialog.formData = JSON.parse(JSON.stringify(data))
      } else {
        // 重置数据
        this.roleDialog.formData = {
          name: '',
          remark: ''
        }
      }
      this.roleDialog.visible = true
      // 清空验证信息
      this.$nextTick(() => {
        this.$refs.roleForm.clearValidate()
      })
    },
    // 页码变更
    currentPageChange(page) {
      this.table.query.page = page
      this.search(false)
    },
    // 删除角色
    deleteRole(id) {
      this.$confirm('此操作将永久删除角色信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteData(id).then(response => {
          if (response.code == 200) {
            // 操作成功
            this.$message.success('操作成功!')
            this.search(false)
          } else {
            // 操作失败
            this.$message.error('操作失败!')
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 获取菜单树
    getMenuTree() {
      getMenus().then(response => {
        if (response.code == 200) {
          // 查询成功
          const menuData = response.data
          for (let i = 1; i < menuData.length; i++) {
            this.menuDialog.data.push(menuData[i])
          }
        } else {
          // 查询失败
          this.$message.error('获取菜单树失败!')
        }
      })
    },
    // 分配菜单
    distributeMenu(data) {
      this.roleDialog.formData = JSON.parse(JSON.stringify(data))
      // 回显数据
      let checkedKeys = []
      const menuIds = this.roleDialog.formData.menuIds
      if (menuIds) {
        const menus = menuIds.split(",");
        for (const menu of menus) {
          if (menu != 1 && menu != 5) {
            checkedKeys.push(parseInt(menu))
          }
        }
      }
      this.menuDialog.visible = true
      // 回显数据
      this.$nextTick(() => {
        this.$refs.menuTree.setCheckedKeys(checkedKeys)
      })
    },
    // 更新菜单权限
    updateRoleMenu() {
      let checkedKeys = this.$refs.menuTree.getCheckedKeys().concat(this.$refs.menuTree.getHalfCheckedKeys())
      if (!checkedKeys || checkedKeys.length == 0) {
        this.$message.error('请分配菜单')
        return
      }
      this.menuDialog.loading = true
      this.roleDialog.formData.menuIds = checkedKeys.join(',')
      saveOrUpdateData(this.roleDialog.formData).then(response => {
        if (response.code == 200) {
          // 操作成功
          this.$message.success('操作成功!')
          this.menuDialog.visible = false
          this.search(false)
        } else {
          // 操作失败
          this.$message.error('操作失败!')
        }
        this.menuDialog.loading = false
      })
    },
    // 格式化菜单显示
    formatMenu(menuIds) {
      if (menuIds) {
        const ids = menuIds.split(',')
        const menus = this.menus.filter(role => ids.indexOf(role.id + '') != -1)
        if (menus && menus.length > 0) {
          return menus.map(menu => menu.name).join(',')
        }
      }
      return '未分配菜单'
    },
    // 获取所有菜单
    getMenus() {
      getAllMenus().then(response => {
        if (response.code == 200) {
          // 查询成功
          this.menus = response.data
          this.search(true)
        } else {
          // 查询失败
          this.$message.error('查询菜单失败!')
        }
      })
    },
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/system/role.vue